module.exports = __webpack_public_path__ + "static/media/CutTextIcon.8cd9ac4a.svg";